(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stawy-motion-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stawy-motion-hero')) {
    customElements.define(
      'stawy-motion-hero',
      class StawyMotionHero extends HTMLElement {
        connectedCallback() {
          this.media = this.querySelector('.stawy-motion-hero__media');
          this.strength = Number(this.dataset.motionStrength) || 0;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.coarsePointer = window.matchMedia('(pointer: coarse)').matches;
          this.pointerHandler = this.handlePointerMove.bind(this);
          this.leaveHandler = this.resetPosition.bind(this);
          this.scrollHandler = this.handleScroll.bind(this);
          this.frame = null;
          this.inView = false;
          this.motionObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView && this.coarsePointer && !this.reducedMotion) this.handleScroll();
          }, { rootMargin: '100px' });
          this.motionObserver.observe(this);

          if (this.reducedMotion || !this.media) return;

          if (this.coarsePointer) {
            window.addEventListener('scroll', this.scrollHandler, { passive: true });
            this.handleScroll();
          } else {
            this.addEventListener('pointermove', this.pointerHandler);
            this.addEventListener('pointerleave', this.leaveHandler);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('pointermove', this.pointerHandler);
          this.removeEventListener('pointerleave', this.leaveHandler);
          window.removeEventListener('scroll', this.scrollHandler);
          this.motionObserver?.disconnect();
          if (this.frame) window.cancelAnimationFrame(this.frame);
        }

        handlePointerMove(event) {
          this.pointerX = event.clientX;
          this.pointerY = event.clientY;
          if (this.frame || !this.inView) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            if (!this.isConnected || !this.inView) return;
            const bounds = this.getBoundingClientRect();
            const x = (this.pointerX - bounds.left) / bounds.width - 0.5;
            const y = (this.pointerY - bounds.top) / bounds.height - 0.5;
            this.media.style.transform = `translate3d(${x * this.strength}px, ${y * this.strength}px, 0) scale(1.08)`;
          });
        }

        resetPosition() {
          if (this.frame) window.cancelAnimationFrame(this.frame);
          this.frame = null;
          this.media.style.transform = 'translate3d(0, 0, 0) scale(1.08)';
        }

        handleScroll() {
          if (this.frame || !this.inView) return;
          this.frame = window.requestAnimationFrame(() => {
            const bounds = this.getBoundingClientRect();
            const viewportCenter = window.innerHeight / 2;
            const sectionCenter = bounds.top + bounds.height / 2;
            const progress = Math.max(-1, Math.min(1, (viewportCenter - sectionCenter) / window.innerHeight));
            this.media.style.transform = `translate3d(0, ${progress * this.strength}px, 0) scale(1.08)`;
            this.frame = null;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stawy-motion-stat"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stawy-motion-stat')) {
    customElements.define(
      'stawy-motion-stat',
      class StawyMotionStat extends HTMLElement {
        connectedCallback() {
          this.media = this.querySelector('.stawy-motion-stat__media');
          this.counter = this.querySelector('[data-stawy-count]');
          this.target = Number(this.counter?.textContent) || 0;
          this.strength = Number(this.dataset.motionStrength) || 0;
          this.duration = Number(this.dataset.countDuration) || 1400;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.coarsePointer = window.matchMedia('(pointer: coarse)').matches;
          this.pointerHandler = this.handlePointerMove.bind(this);
          this.leaveHandler = this.resetPosition.bind(this);
          this.scrollHandler = this.handleScroll.bind(this);
          this.frame = null;
          this.inView = false;
          this.motionObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView && this.coarsePointer && !this.reducedMotion) this.handleScroll();
          }, { rootMargin: '100px' });
          this.motionObserver.observe(this);

          if (!this.reducedMotion && this.media) {
            if (this.coarsePointer) {
              window.addEventListener('scroll', this.scrollHandler, { passive: true });
              this.handleScroll();
            } else {
              this.addEventListener('pointermove', this.pointerHandler);
              this.addEventListener('pointerleave', this.leaveHandler);
            }
          }

          if (this.counter && !this.reducedMotion) {
            this.counter.textContent = '0';
            this.observer = new IntersectionObserver((entries) => {
              if (!entries[0].isIntersecting) return;
              this.observer.disconnect();
              this.animateCount();
            }, { threshold: 0.45 });
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('pointermove', this.pointerHandler);
          this.removeEventListener('pointerleave', this.leaveHandler);
          window.removeEventListener('scroll', this.scrollHandler);
          this.observer?.disconnect();
          this.motionObserver?.disconnect();
          if (this.frame) window.cancelAnimationFrame(this.frame);
        }

        animateCount() {
          const startedAt = performance.now();
          const tick = (now) => {
            const progress = Math.min(1, (now - startedAt) / this.duration);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.counter.textContent = String(Math.round(this.target * eased));
            if (progress < 1) window.requestAnimationFrame(tick);
          };
          window.requestAnimationFrame(tick);
        }

        handlePointerMove(event) {
          this.pointerX = event.clientX;
          this.pointerY = event.clientY;
          if (this.frame || !this.inView) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            if (!this.isConnected || !this.inView) return;
            const bounds = this.getBoundingClientRect();
            const x = (this.pointerX - bounds.left) / bounds.width - 0.5;
            const y = (this.pointerY - bounds.top) / bounds.height - 0.5;
            this.media.style.transform = `translate3d(${x * this.strength}px, ${y * this.strength}px, 0) scale(1.08)`;
          });
        }

        resetPosition() {
          if (this.frame) window.cancelAnimationFrame(this.frame);
          this.frame = null;
          this.media.style.transform = 'translate3d(0, 0, 0) scale(1.08)';
        }

        handleScroll() {
          if (this.frame || !this.inView) return;
          this.frame = window.requestAnimationFrame(() => {
            const bounds = this.getBoundingClientRect();
            const viewportCenter = window.innerHeight / 2;
            const sectionCenter = bounds.top + bounds.height / 2;
            const progress = Math.max(-1, Math.min(1, (viewportCenter - sectionCenter) / window.innerHeight));
            this.media.style.transform = `translate3d(0, ${progress * this.strength}px, 0) scale(1.08)`;
            this.frame = null;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
